// Static McCain menu content
export const MCCAIN_MENU = {
  categories: [
    {
      name: "Appetizers & Sides",
      items: [
        {
          name: "Toasted Pita and Roasted Red Pepper Hummus with Vegetable Sticks",
          tags: ["Vegetarian"],
          price: "$6.18",
          calories: 280
        },
        {
          name: "Mozzarella Sticks",
          price: "$5.75",
          calories: 670
        },
        {
          name: "Cheese Quesadilla",
          tags: ["Vegetarian"],
          price: "$5.75",
          calories: 820
        },
        {
          name: "Wisconsin Battered Cheese Curds",
          tags: ["Vegetarian"],
          price: "$6.18",
          calories: 680
        },
        {
          name: "Garden Salad",
          tags: ["Vegan"],
          price: "$3.50",
          calories: 120
        },
        {
          name: "Caesar Salad",
          tags: ["Vegetarian"],
          price: "$3.50",
          calories: 130
        },
        {
          name: "Steamed Quinoa",
          tags: ["Vegan", "Made without Gluten-Containing Ingredients"],
          price: "$1.50",
          calories: 210
        },
        {
          name: "Steamed Farro",
          tags: ["Vegan"],
          price: "$1.50",
          calories: 220
        },
        {
          name: "Steamed Jasmine Rice",
          tags: ["Vegan", "Made without Gluten-Containing Ingredients"],
          price: "$1.50",
          calories: 190
        }
      ]
    },
    {
      name: "Hot Sandwiches",
      items: [
        {
          name: "Grilled Chicken Sandwich",
          price: "$7.73",
          calories: 340
        },
        {
          name: "Vegan Bacon Bliss on Ciabatta",
          tags: ["Vegan", "Locally Crafted"],
          price: "$7.75",
          calories: 380
        },
        {
          name: "BBQ Western Beef Burger on Brioche Bun",
          tags: ["Farm to Fork", "Locally Crafted"],
          price: "$7.73",
          calories: 740
        },
        {
          name: "BBQ Western Grilled Chicken on Brioche",
          tags: ["Locally Crafted"],
          price: "$7.73",
          calories: 620
        },
        {
          name: "BBQ Western Beyond Burger on Brioche",
          tags: ["Vegetarian", "Locally Crafted"],
          price: "$7.73",
          calories: 690
        },
        {
          name: "Grilled Santa Fe Chicken on Brioche Bun",
          tags: ["Locally Crafted"],
          price: "$7.73",
          calories: 540
        },
        {
          name: "Grilled Santa Fe Beef on Brioche Bun",
          tags: ["Farm to Fork", "Locally Crafted"],
          price: "$7.73",
          calories: 680
        },
        {
          name: "Tuna Melt on Sourdough",
          tags: ["Seafood Watch"],
          price: "$7.73",
          calories: 510
        },
        {
          name: "Classic Cheese Burger on Brioche Bun",
          tags: ["Humane"],
          price: "$7.73",
          calories: 560
        },
        {
          name: "Five Cheese Melt",
          tags: ["Vegetarian"],
          price: "$7.75",
          calories: 590
        },
        {
          name: "Chicken Caesar Wrap",
          price: "$7.50–$8.00",
          calories: 670
        },
        {
          name: "Beyond Burger on Ciabatta",
          tags: ["Vegan"],
          price: "$9.27",
          calories: 380
        }
      ]
    },
    {
      name: "Entrees",
      items: [
        {
          name: "Grilled Chicken Breast",
          tags: ["Made without Gluten-Containing Ingredients"],
          price: "$1.75",
          calories: 190
        },
        {
          name: "Coyote Classic Bowl",
          tags: ["Made without Gluten-Containing Ingredients"],
          price: "$9.27",
          calories: 330
        },
        {
          name: "Chicken Alfredo Pasta",
          price: "$9.75",
          calories: 680
        },
        {
          name: "Pack Leader Bowl",
          price: "$9.27",
          calories: 550
        },
        {
          name: "Howling Orange Bowl",
          tags: ["Made without Gluten-Containing Ingredients"],
          price: "$9.50",
          calories: 330
        }
      ]
    }
  ]
};
